<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<Button type="primary" @click="shuaxinClick">刷新</Button>
		</div>

		<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
			<template slot-scope="{ row, index }" slot="action">

			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
	</div>
</template>
<script>
	let _this
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading: false,
				total: 100,
				id: '',
				query: {
					page: 0,
					size: 10,
					macLeaveFactoryId: '', //加盟商id
				},
				columns12: [{
						title: 'id',
						key: 'id',
						align: 'center',
					},
					{
						title: '设备id',
						key: 'macLeaveFactory',
						align: 'center',
						render: (h, params) => {
							return h("div", params.row.macLeaveFactory.id)
						}
					},
					{
						title: '设备mac',
						key: 'macLeaveFactory',
						align: 'center',
						render: (h, params) => {
							return h("div", params.row.macLeaveFactory.uuid1)
						}
					},
					{
						title: '设备故障描述',
						key: 'remark',
						align: 'center'
					},
					{
						title: '上报时间',
						key: 'createdTime',
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: []

			}
		},
		created() {
			_this = this
			_this.query.macLeaveFactoryId = this.$route.query.id
			this.ajaxPage()
		},
		methods: {

			ret() { //返回上一页
				this.$router.go(-1)
			},
			shuaxinClick() {
				this.onchange()
			},




			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			onchange() {
				this.query.page = 0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/fault/details/page1',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.loading = false
						_this.total = data.data.totalElements
						_this.data6 = data.data.content

					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			}
		},
		components: {
			page
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}

	/* .fontsize /deep/ .ivu-modal{
		.ivu-modal-footer{
			text-align: center !important;
		}
	} */
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/mac/gz/list.vue